import React from "react";
import iconSpack from "../../../../../assets/images/Event-2024/icon-diem-event.png";
import iconVo from "../../../../../assets/images/Event-2024/Asset 4@4x (1).png";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { curStateEventNewYear2024 } from "../../../../../Redux/selector";

export default function AddItemEvent2024({ total = 0, isBid}) {
  const { statusEvent } = useSelector(curStateEventNewYear2024) || {};

  if (!statusEvent?.is_show || statusEvent?.is_finished) {
    return;
  }

  return (
    <Component className="event-2024-add-spark">
      <div className="container-add-spark">
        <img src={isBid ? iconSpack : iconVo} alt="" />
        <div className="number-spark">
          {`+${total || "0"}`}
        </div>
      </div>
    </Component>
  );
}

const Component = styled.div`
  position: fixed;
  z-index: 9999;
  bottom: 50%;
  right: 50%;
  transform: translate(50%, 50%);
  animation: fly-to-corner 3s ease-in-out forwards;

  .container-add-spark {
    position: relative;
  }

  .number-spark {
    position: absolute;
    top: -20px;
    left: 50%;
    transform: translateX(-50%);
    filter: drop-shadow(1px 0 0 #242724) drop-shadow(-1px 0 0 #242724) drop-shadow(0 1px 0 #242724) drop-shadow(0 -1px 0 #242724);
    font-size: 42px;
    color: white;
  }

  @keyframes fly-to-corner {
    0% {
      bottom: 50%;
      right: 50%;
      transform: translate(50%, 50%);
      opacity: 1;
    }
    90% {
      right: 25px;
      bottom: 20px;
      transform: translate(0, 0);
      opacity: 1;
      scale: 1;
    }

    100% {
      right: 25px;
      bottom: 20px;
      transform: translate(0, 0);
      opacity: 0;
      display: none;
      scale: 0.6;
    }
  }

  @media (max-width: 992px) {
    @keyframes fly-to-corner {
    0% {
      bottom: 50%;
      right: 50%;
      transform: translate(50%, 50%);
      opacity: 1;
    }
    90% {
      right: 25px;
      bottom: 70px;
      transform: translate(0, 0);
      opacity: 1;
      scale: 1;
    }

    100% {
      right: 25px;
      bottom: 70px;
      transform: translate(0, 0);
      opacity: 0;
      display: none;
      scale: 0.6;
    }
  }
  }

  @media (max-width: 576px) {
    @keyframes fly-to-corner {
    0% {
      bottom: 50%;
      right: 50%;
      transform: translate(50%, 50%);
      opacity: 1;
    }
    90% {
      right: 5px;
      bottom: 70px;
      transform: translate(0, 0);
      opacity: 1;
      scale: 1;
    }

    100% {
      right: 5px;
      bottom: 70px;
      transform: translate(0, 0);
      opacity: 0;
      display: none;
      scale: 0.6;
    }
  }
  }
`;
